// cascader级联,树形控件 数据处理
/**
 * 将源数据处理后使用目标数据接收
 * @param {Object} s_data 源数据
 * @param {Object} t_data 目标数据
 * @param {Array} t_key 对应字段 id,value,label,pid
 */
export function resolveCascaderData(s_data, t_data, t_key) {
  s_data.map(v => {
    var obj = {
      id: v[t_key[0]],
      value: v[t_key[1]],
      label: v[t_key[2]],
      pid: v[t_key[3]]
    }
    if (v.children) {
      obj.children = []
      resolveCascaderData(v.children, obj.children)
    }
    t_data.push(obj)
  })
}
// 四舍五入保留2位小数（不够位数，则用0替补）
export function keepTwoDecimalFull(num) {
  var result = parseFloat(num)
  if (isNaN(result)) {
    // alert('传递参数错误，请检查！');
    return false
  }
  result = Math.round(num * 100) / 100
  var s_x = result.toString()
  var pos_decimal = s_x.indexOf('.')
  if (pos_decimal < 0) {
    pos_decimal = s_x.length
    s_x += '.'
  }
  while (s_x.length <= pos_decimal + 2) {
    s_x += '0'
  }
  return s_x
}
// 完善四舍五入保留2位小数
export function roundNumber(number, decimals) {
  const factor = 10 ** decimals
  return Math.round(number * factor) / factor
}
